/**
 * Composable for displaying field values in tooltips
 * Returns a function that converts values to displayable strings
 */
export const useFieldTooltip = () => {
  /**
   * Get a human-readable display value for tooltips
   * @param {*} value - The field value to display
   * @returns {{text: string|undefined, disabled: boolean}} - Formatted string or null if value shouldn't be displayed
   */
  const getTooltipDisplayValue = (value) => {
    // Don't show tooltip for null, undefined, empty strings, or objects
    if (value === null || value === undefined || value === "" || typeof value === "object") {
      return {
        text: undefined,
        disabled: true,
      };
    }

    // Convert to string for all other types
    return {
      text: String(value),
      disabled: false,
    };
  };

  return {
    getTooltipDisplayValue,
  };
};
